module.exports = __webpack_public_path__ + "img/silver.71aeba26.svg";